import React, { useState, useEffect } from 'react';
import { getUnpaidInvoices } from '../../api/adminApi';
import LoadingData from '../../components/LoadingData';
import { theme } from '../../adminTheme';

export default function UnpaidPage() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getUnpaidInvoices();
        setInvoices(res.data.invoices);
      } catch { /* ignore */ }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  if (loading) return <LoadingData />;

  const byUser = {};
  invoices.forEach((inv) => {
    const uid = inv.user?.id || 'unknown';
    if (!byUser[uid]) byUser[uid] = { user: inv.user, invoices: [], total: 0 };
    byUser[uid].invoices.push(inv);
    byUser[uid].total += inv.fee_amount;
  });

  const sorted = Object.values(byUser).sort((a, b) => b.total - a.total);

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Facturas Impagas</h1>
      {sorted.length === 0
        ? <p style={{ color: theme.textMuted }}>No hay facturas impagas</p>
        : (
          <div style={{ overflowX: 'auto' }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>#</th>
                  <th style={styles.th}>Usuario</th>
                  <th style={styles.th}>Email</th>
                  <th style={styles.th}>Facturas</th>
                  <th style={styles.th}>Monto Adeudado</th>
                  <th style={styles.th}>Desde</th>
                </tr>
              </thead>
              <tbody>
                {sorted.map((group, idx) => {
                  const dates = group.invoices.map(i => i.created_at).sort();
                  return (
                    <tr key={group.user?.id || idx} style={{ backgroundColor: idx % 2 === 0 ? theme.tableRow : theme.tableRowAlt }}>
                      <td style={styles.td}>{idx + 1}</td>
                      <td style={styles.td}><strong style={{ color: theme.text }}>{group.user?.username || 'Unknown'}</strong></td>
                      <td style={styles.td}>{group.user?.email || '-'}</td>
                      <td style={styles.td}>{group.invoices.length}</td>
                      <td style={{ ...styles.td, fontWeight: 600, color: theme.error }}>${group.total.toFixed(2)}</td>
                      <td style={styles.td}>{dates[0] ? new Date(dates[0]).toLocaleDateString() : '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}

const styles = {
  container: { padding: '24px', minHeight: '100vh' },
  title: { margin: '0 0 24px 0', fontSize: '1.5rem', color: theme.text },
  table: { width: '100%', borderCollapse: 'collapse', borderRadius: '8px', overflow: 'hidden', border: `1px solid ${theme.border}` },
  th: { textAlign: 'left', padding: '12px 16px', borderBottom: `1px solid ${theme.border}`, fontSize: '0.85rem', color: theme.textMuted, fontWeight: 600, backgroundColor: theme.tableHeader },
  td: { padding: '12px 16px', borderBottom: `1px solid ${theme.border}`, fontSize: '0.9rem', color: theme.text },
};
